import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import ScrollToTop from './components/layouts/ScrollToTop';

import NavBar from "./components/layouts/NavBar";

import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Loader from './components/layouts/Loader';

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {

    setTimeout(() => {

      setLoading(false);

    }, 4000);

  }, []);

  return (

    <>

      {loading ?

        <div className="loading__container">

          <Loader />

        </div>

        :

        <Router>

          <ScrollToTop />

          <ToastContainer />

          <NavBar />

          <Routes>

            <Route path='/' element={<Home />} />
            <Route path='/portfolio' element={<Portfolio />} />
            <Route path='/contato' element={<Contact />} />
            <Route path='*' element={<Home/>} />

          </Routes>

        </Router>

      }

    </>

  );

}

export default App;
